<!--物业报修确认-->
<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>

<script>
import propertyRepairConfirmDetail from "./detail";
import propertyRepairConfirmList from "./list";
export default {
  name: "property-repair-confirm",
  components:{
    propertyRepairConfirmList,
    propertyRepairConfirmDetail,
  },
  watch:{
    '$route.path':function (newval) {
      if(newval.includes('/detail')){
        this.componentName = 'propertyRepairConfirmDetail'
        return;
      }
      if(newval.includes('/checkModule/property-service/property-repair-confirm')){
        this.componentName = 'propertyRepairConfirmList'
      }
    }
  },
  data(){
    return {
      componentName:'propertyRepairConfirmList'
    }
  }
}
</script>

<style scoped>

</style>